import type { SettingsKV } from './db';
import { db } from './db';

export async function get<T = unknown>(key: string): Promise<T | undefined> {
  const record = await db.settings_kv.get(key);
  return record?.value as T | undefined;
}

export async function set<T = unknown>(key: string, value: T): Promise<void> {
  await db.settings_kv.put({
    key,
    value,
    updatedAt: Date.now(),
  });
}

export async function deleteSetting(key: string): Promise<void> {
  await db.settings_kv.delete(key);
}

export async function list(): Promise<SettingsKV[]> {
  return db.settings_kv.toArray();
}
